module.exports = __webpack_public_path__ + "static/media/profile.94eb9884.jpg";